import { http } from '../client';
import type { CountsApi } from './counts';

// Paths mirror subsystems/platform/facade/adapters/admin-api/src/admin/counts.rs.
export const countsHttp: CountsApi = {
  getCounts: (opts) => http.get('api', '/counts', { signal: opts?.signal }),
  getMonthlyRevenue: (q, opts) => http.get('api', '/counts/revenue', { query: { ...q }, signal: opts?.signal }),
};
